import BundlesPage from './BundlesPage';
import { ITNPackagePage } from './ITNPackagePage';

export {
    BundlesPage,
    ITNPackagePage,
}



// WEBPACK FOOTER //
// src/client/components/common/purchases/index.js